<div class="padding-bottom-15">
    <mat-label [ngClass]="inputBoxData.titleClass">{{inputBoxData.title}}</mat-label><br>
    <input type="text" class="width-100 border-ccc" pInputText
      (keydown)="onKeyDown($event)"
      (paste)="onPaste($event)"
      (keyup)="emitValue()"
      [(ngModel)]="enteredText"
      placeholder="{{inputBoxData.placeholder}}"
      [attr.inputmode]="numericOnly ? (allowDecimal ? 'decimal' : 'numeric') : null"/>
</div>
